











import { Component, Vue } from 'vue-property-decorator';
import WithdrawTips from '@/components/WithdrawTips.vue';

@Component({
  components: {
    WithdrawTips,
  }
})
export default class WithdrawSuccess extends Vue{
  mounted(){
    this.$as.send('loaded_page_WithdrawSuccess');
  }

  backToHome() {
    this.$as.send('click_backtohome_btn_WithdrawSuccess')
    this.$router.push('/');
  }
}
